// Route SEO (title, description, canonical, JSON-LD). Shared by <Seo /> and scripts/prerender-seo.js.
import { META, SITE_URL, COMPANY, HEROES } from "./site.js";
import { areaBySlug, areaPath, cityTitle, cityH1, cityFaqs } from "./areas.js";

export const ORG = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#org`,
  name: COMPANY.name,
  alternateName: COMPANY.long,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/brand/logo-light.png`,
  telephone: "+442475222999",
  email: COMPANY.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: `${COMPANY.address[0]}, ${COMPANY.address[1]}`,
    addressLocality: COMPANY.address[2],
    postalCode: COMPANY.address[3],
    addressCountry: "GB",
  },
};

const crumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

const shortName = (title) => title.split(/ — | \| /)[0];

const cityJsonLd = (a, description) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Service",
      name: cityH1(a),
      serviceType: "Emergency property repairs and 24/7 call-out",
      description,
      url: `${SITE_URL}${areaPath(a)}`,
      areaServed: { "@type": "City", name: a.fullName },
      provider: ORG,
    },
    crumbs([["Home", "/"], ["Areas We Cover", "/areas"], [a.name, areaPath(a)]]),
    {
      "@type": "FAQPage",
      mainEntity: cityFaqs(a).map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  ],
});

export const routeSeo = (path, metaKey) => {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const area = path.startsWith("/areas/") && areaBySlug(path.slice(7));
  if (area) return { title: cityTitle(area), description: area.meta, url, jsonLd: cityJsonLd(area, area.meta) };
  const m = META[metaKey || path] || META["/"];
  const jsonLd = path === "/"
    ? { "@context": "https://schema.org", ...ORG }
    : META[path] && { "@context": "https://schema.org", ...crumbs([["Home", "/"], [HEROES[path]?.eyebrow || shortName(m.title), path]]) };
  return { title: m.title, description: m.description, url, jsonLd };
};
